

export enum EDraftIssuePaginationType {
  INIT = "INIT",
  NEXT = "NEXT",
  PREV = "PREV",
  CURRENT = "CURRENT",
}
